
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/user/reward/vesting",
      function () {
        return require("private-next-pages/user/reward/vesting.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/user/reward/vesting"])
      });
    }
  